const baseUserUrl = process.env.REACT_APP_ROOT_USER_API;
const baseAdminPanel = process.env.REACT_APP_ADMIN_PANEL_API;
const baseSaleUrl = process.env.REACT_APP_ROOT_SALE_API;
const baseWarehous = process.env.REACT_APP_ROOT_WAREHOUSE;

const apiUrl = {
  //Users
  getToken: baseUserUrl + "/api/UserAuth/GetToken",
  registerUser: baseUserUrl + "/api/UserAuth/RegisterUser",
  otpRegisterUser: baseUserUrl + "/api/UserAuth/OtpRegisterUser",
  confirmOtp: baseUserUrl + "/api/UserAuth/ConfirmOtp",
  getUserProfile: baseUserUrl + "/api/UserProfileApi/GetUserProfile",
  getUserInfo: baseUserUrl + "/api/UserProfileApi/GetUserInfo",
  updateProfile: baseUserUrl + "/api/UserProfileApi/UpdateUserProfile",
  getUserBranches: baseUserUrl + "/api/BranchApi/GetUserBranches",
  createBranch: baseUserUrl + "/api/BranchApi/CreateBranch",
  deleteBranch: baseUserUrl + "/api/BranchApi/DeleteBranch/",
  getBranchInfo: baseUserUrl + "/api/BranchApi/GetMyBranchInfo",
  getRestaurantInfo : baseUserUrl + "/api/RestaurantApi/GetRestaurantInfo",
  getRestaurantBranches : baseUserUrl + "/api/RestaurantApi/GetRestaurantBranches",
  getCreditMerchants: baseUserUrl + "/api/UserAccountApi/GetCreditMerchants",
  getMerchantWalletInfo:
    baseUserUrl + "/api/UserAccountApi/GetMerchantWalletInfo",
  createMerchantWallet:
    baseUserUrl + "/api/UserAccountApi/CreateMerchantWallet",
  changeCreditableMerchant:
    baseUserUrl + "/api/UserAccountApi/ChangeCreditableMerchant/",
  // getUserRestaurants: baseUserUrl + "/api/RestaurantApi/GetUserRestaurants",
  findRolesForEmployee:
    baseUserUrl + "/api/BranchStaffApi/FindRolesForEmployee",
  getEmployeeRoles: baseUserUrl + "/api/BranchStaffApi/GetEmployeeRoles",
  addRoleToEmployee: baseUserUrl + "/api/BranchStaffApi/AddRoleToEmployee",
  removeRoleFromEmployee:
    baseUserUrl + "/api/BranchStaffApi/RemoveRoleFromEmployee",
  getEmployeeTypes: baseUserUrl + "/api/BranchStaffApi/GetEmployeeTypes",
  getEmployees: baseUserUrl + "/api/BranchStaffApi/GetEmployees",
  getWaiters: baseUserUrl + "/api/BranchStaffApi/GetWaiters",
  getEmployeeInfo: baseUserUrl + "/api/BranchStaffApi/GetEmployeeInfo",
  createEmployee: baseUserUrl + "/api/BranchStaffApi/CreateEmployee",
  changeActivationEmployee:
    baseUserUrl + "/api/BranchStaffApi/ChangeActivationEmployee",
  removeEmployee: baseUserUrl + "/api/BranchStaffApi/RemoveEmployee/",
  getMerchants: baseUserUrl + "/api/MerchantApi/GetMerchants",
  getMerchantInfo: baseUserUrl + "/api/MerchantApi/GetMerchantInfo",
  createMerchant: baseUserUrl + "/api/MerchantApi/CreateMerchant",
  getMerchantAndAddressesInfo:
    baseUserUrl + "/api/MerchantApi/GetMerchantAndAddressesInfo",
  createMerchantWithAddress:
    baseUserUrl + "/api/MerchantApi/CreateMerchantWithAddress",
  getUserAddresses: baseUserUrl + "/api/UserAddressApi/GetUserAddresses",
  getUserAddressInfo: baseUserUrl + "/api/UserAddressApi/GetUserAddressInfo",
  createUserAddress: baseUserUrl + "/api/UserAddressApi/CreateUserAddress",
  removeUserAddress: baseUserUrl + "/api/UserAddressApi/RemoveUserAddress/",
  getLoginedWaiterInfo:
    baseUserUrl + "/api/BranchStaffApi/GetLoginedWaiterInfo",
  getLoginedStaffInfo: baseUserUrl + "/api/BranchStaffApi/GetLoginedStaffInfo",
  removeMerchant: baseUserUrl + "/api/MerchantApi/RemoveMerchant",
  getMerchantAdresses: baseUserUrl + "/api/MerchantApi/GetMerchantAdresses",
  getAddressInfo: baseUserUrl + "/api/MerchantApi/GetAddressInfo",
  createAddress: baseUserUrl + "/api/MerchantApi/CreateAddress",
  removeAddress: baseUserUrl + "/api/MerchantApi/RemoveAddress",
  getUserRestaurants: baseUserUrl + "/api/RestaurantApi/GetUserRestaurants",

  //Sales
  getBranchStatus: baseSaleUrl + "/api/BranchSettingApi/GetBranchSalesStatus",
  getProvinces: baseAdminPanel + "/api/LocationApi/GetProvinces",
  getCities: baseAdminPanel + "/api/LocationApi/GetCities",
  uploadFile: baseAdminPanel + "/api/FileManagerApi/UploadFile",
  deleteFile: baseAdminPanel + "/api/FileManagerApi/RemoveFile",
  getAllUnits: baseSaleUrl + "/api/SaleUnitApi/GetAllUnits",
  getUnits: baseSaleUrl + "/api/SaleUnitApi/GetUnits",
  getUnitInfo: baseSaleUrl + "/api/SaleUnitApi/GetUnitInfo",
  createUnit: baseSaleUrl + "/api/SaleUnitApi/CreateUnit",
  removeUnit: baseSaleUrl + "/api/SaleUnitApi/RemoveUnit/",
  getPagers: baseSaleUrl + "/api/PagerApi/GetPagers",
  getPagerInfo: baseSaleUrl + "/api/PagerApi/GetPagerInfo",
  createPager: baseSaleUrl + "/api/PagerApi/CreatePager",
  removePager: baseSaleUrl + "/api/PagerApi/RemovePager/",
  enablePager: baseSaleUrl + "/api/PagerApi/EnablePager/",
  getPrinters: baseSaleUrl + "/api/PrinterApi/GetPrinters",
  getPrinterInfo: baseSaleUrl + "/api/PrinterApi/GetPrinterInfo",
  createPrinter: baseSaleUrl + "/api/PrinterApi/CreatePrinter",
  removePrinter: baseSaleUrl + "/api/PrinterApi/RemovePrinter/",
  getDiningTables: baseSaleUrl + "/api/DiningTableApi/GetDiningTables",
  getDiningTable: baseSaleUrl + "/api/DiningTableApi/GetDiningTable",
  createDiningTable: baseSaleUrl + "/api/DiningTableApi/CreateDiningTable",
  removeDiningTable: baseSaleUrl + "/api/DiningTableApi/RemoveDiningTable/",

  getCashDesks: baseSaleUrl + "/api/CashdeskApi/GetCashdesks",
  getCashDeskInfo: baseSaleUrl + "/api/CashdeskApi/GetCashdeskInfo",
  createCashdesk: baseSaleUrl + "/api/CashdeskApi/CreateCashdesk",
  removeCashDesk: baseSaleUrl + "/api/CashdeskApi/RemoveCashDesk/",
  getDeskActivities: baseSaleUrl + "/api/CashdeskApi/GetDeskActivities",
  getDeskActivityInfo: baseSaleUrl + "/api/CashdeskApi/GetDeskActivityInfo",
  createDeskActivity: baseSaleUrl + "/api/CashdeskApi/CreateDeskActivity",
  openCashDesk: baseSaleUrl + "/api/CashdeskApi/OpenCashDesk/",
  closeCashDesk: baseSaleUrl + "/api/CashdeskApi/CloseCashDesk/",
  getCashDeskReport: baseSaleUrl + "/api/CashdeskApi/GetCashDeskReport",
  getCashdeskCredits: baseSaleUrl + "/api/CashdeskApi/GetCashdeskCredits",
  getCashDeskUsers: baseSaleUrl + "/api/CashdeskApi/GetCashDeskUsers",
  createCashDeskUser: baseSaleUrl + "/api/CashdeskApi/CreateCashDeskUser",
  removeCashDeskUser: baseSaleUrl + "/api/CashdeskApi/RemoveCashDeskUser/",
  findCahiers: baseSaleUrl + "/api/CashdeskApi/FindCahiers",
  findCashDeskPrinters: baseSaleUrl + "/api/CashdeskApi/FindPrinters",
  getDeskPrinters: baseSaleUrl + "/api/CashdeskApi/GetDeskPrinters",
  createDeskPrinter: baseSaleUrl + "/api/CashdeskApi/CreateDeskPrinter",
  removeDeskPrinter: baseSaleUrl + "/api/CashdeskApi/RemoveDeskPrinter/",
  findPosDevices: baseSaleUrl + "/api/CashdeskApi/FindPosDevices",
  getDeskPosDevices: baseSaleUrl + "/api/CashdeskApi/GetDeskPosDevices",
  createDeskPos: baseSaleUrl + "/api/CashdeskApi/CreateDeskPos",
  removeDeskPos: baseSaleUrl + "/api/CashdeskApi/RemoveDeskPos/",
  getPoses: baseSaleUrl + "/api/PosDeviceApi/GetPosDevices",
  getPosInfo: baseSaleUrl + "/api/PosDeviceApi/GetPosDeviceInfo",
  createPos: baseSaleUrl + "/api/PosDeviceApi/CreatePosDevice",
  removePosDevice: baseSaleUrl + "/api/PosDeviceApi/RemovePosDevice/",
  getPosProviders: baseSaleUrl + "/api/PosDeviceApi/GetPosProviders",
  getPosProviderInfo: baseSaleUrl + "/api/PosDeviceApi/GetPosProviderInfo",
  createPosProvider: baseSaleUrl + "/api/PosDeviceApi/CreatePosProvider",
  removePosProvider: baseSaleUrl + "/api/PosDeviceApi/RemoveProvider/",
  initialPosProviders: baseSaleUrl + "/api/PosDeviceApi/InitialPosProviders",
  getShipmentCosts: baseSaleUrl + "/api/ShipmentApi/GetShipmentCosts",
  getShipmentCostInfo: baseSaleUrl + "/api/ShipmentApi/GetShipmentCostInfo",
  createShipmentCost: baseSaleUrl + "/api/ShipmentApi/CreateShipmentCost",
  removeShipmentCost: baseSaleUrl + "/api/ShipmentApi/RemoveShipmentCost/",
  getShipmentTypes: baseSaleUrl + "/api/ShipmentApi/GetShipmentTypes",
  getBranchSettings: baseSaleUrl + "/api/BranchSettingApi/GetBranchSettings",
  getBranchSettingInfo:
    baseSaleUrl + "/api/BranchSettingApi/GetBranchSettingInfo",
  createBranchSetting:
    baseSaleUrl + "/api/BranchSettingApi/CreateBranchSetting",
  getSettingByName: baseSaleUrl + "/api/BranchSettingApi/GetSettingByName",
  refactorBranchSetting:
    baseSaleUrl + "/api/BranchSettingApi/RefactorBranchSetting",
  getAllDeliveries: baseSaleUrl + "/api/DeliveryApi/GetAllDeliveries",
  getDeliveries: baseSaleUrl + "/api/DeliveryApi/GetDeliveries",
  getDriveryOrderArchive : baseSaleUrl + "/api/DeliveryApi/GetDriveryOrderArchive",
  getDeliveredOrderArchive : baseSaleUrl + "/api/DeliveryOrderApi/GetDeliveredOrderArchive",
  getDeliveryInvoices: baseSaleUrl + "/api/DeliveryApi/GetDeliveryInvoices",
  getUserPos: baseSaleUrl + "/api/DeliveryApi/GetUserPos",
  findPosForDelivery: baseSaleUrl + "/api/DeliveryApi/FindPosForDelivery",
  createPosUser: baseSaleUrl + "/api/DeliveryApi/CreatePosUser",
  removePosUser: baseSaleUrl + "/api/DeliveryApi/RemovePosUser/",
  getPosSummationReport: baseSaleUrl + "/api/PaymentApi/GetPosSummationReport",
  getPosReport: baseSaleUrl + "/api/PaymentApi/GetPosReport",
  getMenuCategories: baseSaleUrl + "/api/SalesMenuApi/GetMenuCategories",
  getMenuCategoryInfo: baseSaleUrl + "/api/SalesMenuApi/GetMenuCategoryInfo",
  createMenuCategory: baseSaleUrl + "/api/SalesMenuApi/CreateMenuCategory",
  enableMenuCategory: baseSaleUrl + "/api/SalesMenuApi/EnableMenuCategory/",
  removeMenuCategory: baseSaleUrl + "/api/SalesMenuApi/RemoveMenuCategory/",
  findProductForMenu: baseSaleUrl + "/api/SalesMenuApi/FindProductForMenu",
  getMenus: baseSaleUrl + "/api/SalesMenuApi/GetMenus",
  getMenuInfo: baseSaleUrl + "/api/SalesMenuApi/GetMenuInfo",
  createMenu: baseSaleUrl + "/api/SalesMenuApi/CreateMenu",
  enableMenu: baseSaleUrl + "/api/SalesMenuApi/EnableMenu/",
  removeMenu: baseSaleUrl + "/api/SalesMenuApi/RemoveMenu/",

  getSnappToken: baseSaleUrl + "/api/SnappManagmentApi/GetSnappToken",
  getSnappCategories: baseSaleUrl + "/api/SnappManagmentApi/GetCategories",
  getCategoryInfo: baseSaleUrl + "/api/SnappManagmentApi/GetCategoryInfo",
  findMenuCategoriesForSnapp:
    baseSaleUrl + "/api/SnappManagmentApi/FindSaleMenuCategories",
  createCategory: baseSaleUrl + "/api/SnappManagmentApi/CreateCategory",
  removeSnappCategory: baseSaleUrl + "/api/SnappManagmentApi/RemoveCategory/",
  changeCategoryStatus:
    baseSaleUrl + "/api/SnappManagmentApi/ChangeCategoryStatus",
  getSnappMenus: baseSaleUrl + "/api/SnappManagmentApi/GetMenus",
  findSaleMenusForSnapp: baseSaleUrl + "/api/SnappManagmentApi/FindSaleMenus",
  getSnappMenuInfo: baseSaleUrl + "/api/SnappManagmentApi/GetMenuInfo",
  createMenuSnapp: baseSaleUrl + "/api/SnappManagmentApi/CreateMenu",
  removeMenuSnapp: baseSaleUrl + "/api/SnappManagmentApi/RemoveMenu/",
  changeMenuStatusSnapp:
    baseSaleUrl + "/api/SnappManagmentApi/ChangeMenuStatus",
  getSnappServiceTypes:
    baseSaleUrl + "/api/SnappManagmentApi/GetSnappServiceTypes",
  getSnappServicePrices:
    baseSaleUrl + "/api/SnappManagmentApi/GetSnappServicePrices",
  getSnappServicePriceInfo:
    baseSaleUrl + "/api/SnappManagmentApi/GetSnappServicePriceInfo",
  createSnappServicePrice:
    baseSaleUrl + "/api/SnappManagmentApi/CreateSnappServicePrice",
  removeSnappServicePrice:
    baseSaleUrl + "/api/SnappManagmentApi/RemoveSnappServicePrice/",
  enableSnappServicePrice:
    baseSaleUrl + "/api/SnappManagmentApi/EnableSnappServicePrice/",

  getToppingCategories:
    baseSaleUrl + "/api/SnappManagmentApi/GetToppingCategories",
  getSnappCategoryInfo:
    baseSaleUrl + "/api/SnappManagmentApi/GetSnappCategoryInfo",
  createToppingCategory:
    baseSaleUrl + "/api/SnappManagmentApi/CreateToppingCategory",
  getSnappToppings: baseSaleUrl + "/api/SnappManagmentApi/GetToppings",
  getToppingInfo: baseSaleUrl + "/api/SnappManagmentApi/GetToppingInfo",
  createTopping: baseSaleUrl + "/api/SnappManagmentApi/CreateTopping",
  getDierctAllToppings:
    baseSaleUrl + "/api/SnappManagmentApi/GetDierctAllToppings",
  syncCategoryToppings:
    baseSaleUrl + "/api/SnappManagmentApi/SyncCategoryToppings",
  findToppingsForMenu:
    baseSaleUrl + "/api/SnappManagmentApi/FindToppingsForMenu",
  getSnappMenuToppings:
    baseSaleUrl + "/api/SnappManagmentApi/GetSnappMenuToppings",
  addToppingToMenu: baseSaleUrl + "/api/SnappManagmentApi/AddToppingToMenu",
  addBulkyToppingToMenu:
    baseSaleUrl + "/api/SnappManagmentApi/AddBulkyToppingToMenu",
  removeToppingFromMenu:
    baseSaleUrl + "/api/SnappManagmentApi/RemoveToppingFromMenu",
  getSnappRecordes: baseSaleUrl + "/api/SnappManagmentApi/GetSnappRecordes",
  syncSnappCategory: baseSaleUrl + "/api/SnappManagmentApi/SyncSnappCategory",
  syncSnappMenu: baseSaleUrl + "/api/SnappManagmentApi/SyncSnappMenu",

  snappWatch: baseSaleUrl + "/api/SnappOrderApi/SnappWatch",
  getSnappStatuses: baseSaleUrl + "/api/SnappOrderApi/GetSnappStatuses",
  getSnappOrders: baseSaleUrl + "/api/SnappOrderApi/GetSnappOrders",
  getWatchItemInfo: baseSaleUrl + "/api/SnappOrderApi/GetWatchItemInfo",
  verifySnappOrder: baseSaleUrl + "/api/SnappOrderApi/VerifyOrder",
  pickSnappOrder: baseSaleUrl + "/api/SnappOrderApi/PickOrder",
  pickSnappOrderDierctly: baseSaleUrl + "/api/SnappOrderApi/PickOrderDierctly",
  acceptSnappOrder: baseSaleUrl + "/api/SnappOrderApi/AcceptOrder",
  rejectSnappOrder: baseSaleUrl + "/api/SnappOrderApi/RejectOrder",
  getSnappRejectReasons: baseSaleUrl + "/api/SnappOrderApi/GetRejectReasons",
  searchSnappProducts: baseSaleUrl + "/api/SnappOrderApi/SearchSnappProducts",
  acceptAndImportSnappOrder:
    baseSaleUrl + "/api/SnappOrderApi/AcceptAndImportSnappOrder",
  getSnappOrderPrintInfo:
    baseSaleUrl + "/api/SnappOrderApi/GetSnappOrderPrintInfo",

  getServicePriceTypes:
    baseSaleUrl + "/api/ServicePriceApi/GetServicePriceTypes",
  findProducts: baseSaleUrl + "/api/ServicePriceApi/FindProducts",
  getServices: baseSaleUrl + "/api/ServicePriceApi/GetServices",
  getServiceInfo: baseSaleUrl + "/api/ServicePriceApi/GetServiceInfo",
  createService: baseSaleUrl + "/api/ServicePriceApi/CreateService",
  removeService: baseSaleUrl + "/api/ServicePriceApi/RemoveService/",
  enableService: baseSaleUrl + "/api/ServicePriceApi/EnableService/",
  useInInvoice: baseSaleUrl + "/api/ServicePriceApi/UseInInvoice/",
  getOrderingBaseInfo: baseSaleUrl + "/api/FoodOrderApi/GetOrderingBaseInfo",
  getUserCashdesks: baseSaleUrl + "/api/FoodOrderApi/GetUserCashdesks",
  getOrderTypes: baseSaleUrl + "/api/FoodOrderApi/GetOrderTypes",
  getInvoiceItemTypes: baseSaleUrl + "/api/FoodOrderApi/GetInvoiceItemTypes",
  getBranchSaleUnits: baseSaleUrl + "/api/FoodOrderApi/GetBranchSaleUnits",
  getMenuCategoriesOrders: baseSaleUrl + "/api/FoodOrderApi/GetMenuCategories",
  getOrderSaleMenus: baseSaleUrl + "/api/FoodOrderApi/GetSaleMenus",
  findOrdersMerchants: baseSaleUrl + "/api/FoodOrderApi/FindMerchants",
  getBulkOrderInfo: baseSaleUrl + "/api/FoodOrderApi/GetBulkOrderInfo",
  getCashdeskOrders: baseSaleUrl + "/api/FoodOrderApi/GetCashdeskOrders",
  getCanceledOrders: baseSaleUrl + "/api/FoodOrderApi/GetCanceledOrders",
  setTotalDiscount: baseSaleUrl + "/api/FoodOrderApi/SetTotalDiscount",
  getMerchantPreviousOrders:
    baseSaleUrl + "/api/FoodOrderApi/GetMerchantPreviousOrders",
  createBulkOrder: baseSaleUrl + "/api/FoodOrderApi/CreateBulkOrder",
  createOrder: baseSaleUrl + "/api/FoodOrderApi/CreateOrder",
  removeOrder: baseSaleUrl + "/api/FoodOrderApi/RemoveOrder/",
  getOrderItems: baseSaleUrl + "/api/FoodOrderApi/GetOrderItems",
  getOrderItemInfo: baseSaleUrl + "/api/FoodOrderApi/GetOrderItemInfo",
  createOrderItem: baseSaleUrl + "/api/FoodOrderApi/CreateOrderItem",
  removeOrderItem: baseSaleUrl + "/api/FoodOrderApi/RemoveOrderItem/",
  changeOrderItemAmount:
    baseSaleUrl + "/api/FoodOrderApi/ChangeOrderItemAmount",
  sendOrderToKitchen: baseSaleUrl + "/api/FoodOrderApi/SendOrderToKitchen/",
  cancelOrder: baseSaleUrl + "/api/FoodOrderApi/CancelOrder/",

  addMenuToOrderItem: baseSaleUrl + "/api/FoodOrderApi/AddMenuToOrderItem",
  removeMenuFromOrderItem:
    baseSaleUrl + "/api/FoodOrderApi/RemoveMenuFromOrderItem",

  getOrderStatuses: baseSaleUrl + "/api/FoodOrderApi/GetOrderStatuses",
  getInvoices: baseSaleUrl + "/api/FoodOrderApi/GetInvoices",
  createInvoice: baseSaleUrl + "/api/FoodOrderApi/CreateInvoice",
  getPaymentTypes: baseSaleUrl + "/api/PaymentApi/GetPaymentTypes",
  getOrderDeskPosDevices: baseSaleUrl + "/api/FoodOrderApi/GetDeskPosDevices",
  getOrderPrintInfo: baseSaleUrl + "/api/FoodOrderApi/GetOrderPrintInfo",
  getOrderNoTaxPrintInfo:
    baseSaleUrl + "/api/FoodOrderApi/GetOrderNoTaxPrintInfo",
  getLocalPrinters: "/api/LocalPrinterApi/GetPrinters",
  printImage: "/api/LocalPrinterApi/PrintImage",
  kitchenCorrectionPrint: "/api/LocalPrinterApi/KitchenCorrectionPrint",
  kitchenOrderPrint: "/api/LocalPrinterApi/KitchenOrderPrint",
  orderBillPrint: "/api/LocalPrinterApi/OrderBillPrint",

  getOfficialInvoiceExcelFile: baseSaleUrl + "/api/InvoiceManager/GetOfficialInvoiceExcelFile",

  orderPayment: baseSaleUrl + "/api/PaymentApi/OrderPayment",
  cancelPayment: baseSaleUrl + "/api/PaymentApi/CancelPayment",
  getKitchenOrders: baseSaleUrl + "/api/KitchenApi/GetKitchenOrders",
  getKitchenArchive : baseSaleUrl + "/api/KitchenApi/GetKitchenArchive",
  changeToCookedOrder: baseSaleUrl + "/api/KitchenApi/ChangeToCookedOrder/",
  backToCurrentOrder: baseSaleUrl + "/api/KitchenApi/BackToCurrentOrder/",
  kitchenCancelOrder: baseSaleUrl + "/api/KitchenApi/CancelOrder/",
  getCoockedOrders: baseSaleUrl + "/api/DeliveryOrderApi/GetCoockedOrders",
  deliveryOrderToDriver:
    baseSaleUrl + "/api/DeliveryOrderApi/DeliveryOrderToDriver",
  deliveryOrderToDriverBulky:
    baseSaleUrl + "/api/DeliveryOrderApi/DeliveryOrderToDriverBulky",
  deliveryOrderToShipment:
    baseSaleUrl + "/api/DeliveryOrderApi/DeliveryOrderToShipment",
  deliveryOrderToMerchant:
    baseSaleUrl + "/api/DeliveryOrderApi/DeliveryOrderToMerchant/",
  deliveryOrderToWaiter:
    baseSaleUrl + "/api/DeliveryOrderApi/DeliveryOrderToWaiter",
  getDeliveryUserOrders:
    baseSaleUrl + "/api/DeliveryOrderApi/GetDeliveryUserOrders",
  getUserPosDevices: baseSaleUrl + "/api/DeliveryOrderApi/GetUserPosDevices",
  confirmOrder: baseSaleUrl + "/api/DeliveryOrderApi/ConfirmOrder/",
  getBranchOrderCounts:
    baseSaleUrl + "/api/SalesReportApi/GetBranchOrderCounts",
  getCallCenterInfo: baseSaleUrl + "/api/CallCenterApi/GetCallCenterInfo",
  createCallCenterInfo: baseSaleUrl + "/api/CallCenterApi/CreateCallCenterInfo",
  removeCallcenter : baseSaleUrl + "/api/CallCenterApi/CreateCallCenterInfo/",
  getSalesUnitShopQrImage: baseSaleUrl + "/api/SaleUnitApi/GetSalesUnitShopQrImage",
  getSalesProductReport:
    baseSaleUrl + "/api/SalesReportApi/GetSalesProductReport",
  getSalesInvoiceReport:
    baseSaleUrl + "/api/SalesReportApi/GetSalesInvoiceReport",
  getSalesInvoiceItemReport:
    baseSaleUrl + "/api/SalesReportApi/GetSalesInvoiceItemReport",
  getSalesTotalReport: baseSaleUrl + "/api/SalesReportApi/GetSalesTotalReport",
  getMerchantReport: baseSaleUrl + "/api/SalesReportApi/GetMerchantReport",
  getSalesProductExcel:
    baseSaleUrl + "/api/SalesReportApi/GetSalesProductExcel",
  getSalesInvoiceExcel:
    baseSaleUrl + "/api/SalesReportApi/GetSalesInvoiceExcel",
  getSalesInvoiceItemExcel:
    baseSaleUrl + "/api/SalesReportApi/GetSalesInvoiceItemExcel",
  getMerchantReportExcel:
    baseSaleUrl + "/api/SalesReportApi/GetMerchantReportExcel",
  getSalesTotalExcel: baseSaleUrl + "/api/SalesReportApi/GetSalesTotalExcel",
  getAvalibleCashdesks: baseSaleUrl + "/api/WaiterApi/GetAvalibleCashdesks",
  getSnappSalesReport: baseSaleUrl + "/api/SalesReportApi/GetSnappSalesReport",
  getSnappRejectSides: baseSaleUrl + "/api/SnappOrderApi/GetSnappRejectSides",
  getSnappDeliveryTypes:
    baseSaleUrl + "/api/SnappOrderApi/GetSnappDeliveryTypes",
  getSnappPaymentTypes: baseSaleUrl + "/api/SnappOrderApi/GetSnappPaymentTypes",
  getSnappStatuses: baseSaleUrl + "/api/SnappOrderApi/GetSnappStatuses",

  //warehouse
  getPricingTypes: baseWarehous + "/api/ProductApi/GetPricingTypes",
  getProductCategories: baseWarehous + "/api/ProductApi/GetProductCategories",
  getRestaurantProductCategories : baseWarehous + "/api/ProductApi/GetRestaurantProductCategories",
  getProductCategoryInfo:
    baseWarehous + "/api/ProductApi/GetProductCategoryInfo",
  createProductCategory: baseWarehous + "/api/ProductApi/CreateProductCategory",
  createRestaurantProductCategory : baseWarehous + "/api/ProductApi/CreateRestaurantProductCategory",
  removeProductCategory:
    baseWarehous + "/api/ProductApi/RemoveProductCategory/",
  getMeasurementDimensionTypes:
    baseWarehous + "/api/ProductApi/GetMeasurementDimensionTypes",
  getUnitMeasurements: baseWarehous + "/api/ProductApi/GetUnitMeasurements",
  getRestaurantUnitMeasurements: baseWarehous + "/api/ProductApi/GetRestaurantUnitMeasurements",
  getUnitMeasurementInfo:
    baseWarehous + "/api/ProductApi/GetUnitMeasurementInfo",
  createUnitMeasurement: baseWarehous + "/api/ProductApi/CreateUnitMeasurement",
  createRestaurantUnitMeasurement: baseWarehous + "/api/ProductApi/CreateRestaurantUnitMeasurement",
  enableUnitMeasurement:
    baseWarehous + "/api/ProductApi/EnableUnitMeasurement/",
  removeUnitMeasurement:
    baseWarehous + "/api/ProductApi/RemoveUnitMeasurement/",
  getProductTypes: baseWarehous + "/api/ProductApi/GetProductTypes",
  getNatureType: baseWarehous + "/api/ProductApi/GetNatureType",
  getProducts: baseWarehous + "/api/ProductApi/GetProducts",
  getRestaurantProducts: baseWarehous + "/api/ProductApi/GetRestaurantProducts",
  getRestaurantServices: baseWarehous + "/api/ProductApi/GetRestaurantServices",
  getProductMeasurements : baseWarehous + "/api/ProductApi/GetProductMeasurements",
  getProductInfo: baseWarehous + "/api/ProductApi/GetProductInfo",
  getProductMeasurementInfo : baseWarehous + "/api/ProductApi/GetProductMeasurementInfo",
  createProduct: baseWarehous + "/api/ProductApi/CreateProduct",
  createRestaurantProduct: baseWarehous + "/api/ProductApi/CreateRestaurantProduct",
  ceateProductMeasurement : baseWarehous + "/api/ProductApi/CreateProductMeasurement",
  removeProduct: baseWarehous + "/api/ProductApi/RemoveProduct/",
  removeProductMeasurement : baseWarehous + "/api/ProductApi/RemoveProductMeasurement/",
  getWarehouseCategories: baseWarehous + "/api/WarehouseApi/GetWarehouseCategories",
  getWarehouseCategoryInfo: baseWarehous + "/api/WarehouseApi/GetWarehouseCategoryInfo",
  removeWarehouseCategory: baseWarehous + "/api/WarehouseApi/RemoveWarehouseCategory",
  createWarehouseCategory: baseWarehous + "/api/WarehouseApi/CreateWarehouseCategory",
  getAllWarehouseCategories: baseWarehous + "/api/WarehouseApi/GetAllWarehouseCategories",
  getWarehouses: baseWarehous + "/api/WarehouseApi/GetWarehouses",
  getWarehouseInfo: baseWarehous + "/api/WarehouseApi/GetWarehouseInfo",
  createWarehouse: baseWarehous + "/api/WarehouseApi/CreateWarehouse",
  removeWarehouse: baseWarehous + "/api/WarehouseApi/RemoveWarehouse/",
  getWarehouseTypes: baseWarehous + "/api/WarehouseApi/GetWarehouseTypes",
  createSupplier : baseWarehous + "/api/SupplierApi/CreateSupplier",
  getSuppliers : baseWarehous + "/api/SupplierApi/GetSuppliers",
  getSupplierInfo : baseWarehous + "/api/SupplierApi/GetSupplierInfo",
  removeSupplier : baseWarehous + "/api/SupplierApi/RemoveSupplier/",
  findProductForSupplier: baseWarehous + "/api/SupplierApi/FindProductForSupplier",
  getSupplierProducts: baseWarehous + "/api/SupplierApi/GetSupplierProducts",
  createSupplierProduct : baseWarehous + "/api/SupplierApi/CreateSupplierProduct",
  createBulkySupplierProduct : baseWarehous + "/api/SupplierApi/CreateBulkySupplierProduct",
  removeSupplierProduct : baseWarehous + "/api/SupplierApi/RemoveSupplierProduct/",
  findProductForWarehouse : baseWarehous + "/api/WarehouseApi/FindProductForWarehouse",
  createWarehouseProduct : baseWarehous + "/api/WarehouseApi/CreateWarehouseProduct",
  createBulkyWarehouseProduct : baseWarehous + "/api/WarehouseApi/CreateBulkyWarehouseProduct",
  getWarehouseProducts : baseWarehous + "/api/WarehouseApi/GetWarehouseProducts",
  getWarehouseProductInfo : baseWarehous + "/api/WarehouseApi/GetWarehouseProductInfo",
  removeWarehouseProduct : baseWarehous + "/api/WarehouseApi/RemoveWarehouseProduct/",
  getPurchaseOrders : baseWarehous + "/api/PurchaseOrderApi/GetPurchaseOrders",
  createPurchaseOrder : baseWarehous + "/api/PurchaseOrderApi/CreatePurchaseOrder",
  getPurchaseOrderInfo : baseWarehous + "/api/PurchaseOrderApi/GetPurchaseOrderInfo",
  removePurchaseOrder : baseWarehous + "/api/PurchaseOrderApi/RemovePurchaseOrder/",
  findProductForOrder : baseWarehous + "/api/PurchaseOrderApi/FindProductForOrder",
  getProductInfoForPurchase : baseWarehous + "/api/PurchaseOrderApi/GetProductInfoForPurchase",
  getPurchaseOrderItems : baseWarehous + "/api/PurchaseOrderApi/GetPurchaseOrderItems",
  createPurchaseOrderItem : baseWarehous + "/api/PurchaseOrderApi/CreatePurchaseOrderItem",
  getPurchaseOrderItemInfo : baseWarehous + "/api/PurchaseOrderApi/GetPurchaseOrderItemInfo",
  removePurchaseOrderItem : baseWarehous + "/api/PurchaseOrderApi/RemovePurchaseOrderItem/",

  getMerchantInvoicesForSupport:
    baseSaleUrl + "/api/SupportApi/GetMerchantInvoicesForSupport",
  getSalesInvoiceExcel: baseSaleUrl + "/api/SupportApi/GetSalesInvoiceExcel",
  setItemsDiscount: baseSaleUrl + "/api/FoodOrderApi/SetItemsDiscount",
};

export default apiUrl;
